import { ExperienceAnchor } from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../i18next';
import {
  getFixedTimingSummaryText,
  IItemTemplateTimingFixedWithAnchorMode
} from '../../../../../../services/experiences/anchorMode';
import { useMilestoneShortLabel } from '../../../Anchors';
import * as UX from '../../newux/kit';

/** NEW_UX read-only line for a fixed-time item, phrased in the mode the author chose. */
export const FixedTimingSummary = ({
  timing,
  anchor,
  tz
}: {
  timing: IItemTemplateTimingFixedWithAnchorMode;
  anchor: ExperienceAnchor;
  tz: string;
}) => {
  const { t } = useUnsafeTranslation();
  const milestoneLabel = useMilestoneShortLabel(anchor);
  return (
    <UX.TimingSummaryText
      text={getFixedTimingSummaryText(timing, anchor, tz, milestoneLabel, t)}
    />
  );
};
